export const _goalDetailPath = (type) => {

    let path = "";

    switch (type) {
        case "Dream Home":
        case "Home Down Payment": {
            path = "dream-home";
            break;
        }
        case "Retirement Planning": {
            path = "retirement";
            break;
        }
        case "Child's Future": {
            path = "kids-education";
            break;
        }
        case "Wealth Growth": {
            path = "wealth-growth";
            break;
        }
        case "Emergency Fund": {
            path = "emergency-fund";
            break;
        }
        default: {
            path = "goals";
        }
    };

    return path;
};

export const _checkFileSize = (file_size, size = 5) => {

    // 1 mb == 1000000 bytes , we are receiving the file size in bytes so,
    // Converting bytes to mb for easy usage
    let file_size_in_mb = file_size / 1000000;

    if (file_size_in_mb <= size) {
        return true;
    } else {
        return false;
    };

};

export const _formatDateFormat = (selected_date) => {
    const [day, month, year] = selected_date.split("-");
    return new Date(`${year}-${month}-${day}`);
};

export const _parseJwtToken = (token) => {
    if (!token) return null;
    try {
        const base64Url = token.split('.')[1]; // get the payload part
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // decode base64url to base64
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload); // convert to JS object
    } catch (e) {
        console.error("Invalid JWT token", e);
        return null;
    }
};

export const _openOffcanvasModal = () => {
    if (window.innerWidth < 768 && document.querySelector("#offcanvas-modal-btn")) {
        let offcanvas_modal_btn = document.querySelector("#offcanvas-modal-btn");
        offcanvas_modal_btn.click();
    }
};

export const APPLE_AUTH_CONFIG = {
    clientId: 'com.applesign.indexfund',
    redirectURI: 'https://indexfunds.evoqins.dev/signup',
    scope: 'email name',
    state: 'origin:web',
    nonce: 'nonce',
    usePopup: true,
};

// Pages that show only the logo in the sidebar, no menu links and no hamburger on small screens
export const _isMinimalLayout = (pathname) => {
    return pathname === "/invest" || pathname === "/portfolio-check";
};

export const _clearLocalStorage = () => {
    localStorage.removeItem(btoa("show_values"));
    localStorage.removeItem(btoa("show_values_portfolio"));
    localStorage.removeItem("sip_filters");
    localStorage.removeItem("order_filters");
    localStorage.removeItem("portfolio_filters");
    localStorage.removeItem("is_auth_configured");
};
